export default "__VITE_ASSET__khM1bARB__"